export const REGISTER = 'REGISTER';
export const REGISTER_PENDING = 'REGISTER_PENDING';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
